// Detects the mandatory slot-selection gate error returned by the ship
// endpoints (single + bulk requestPickup). The backend responds with this
// code when the merchant has not chosen a pickup time slot yet; callers use
// this helper to intercept the rejection and open the SlotSelectionModal
// instead of showing a generic error toast (see handleErrorMessage, which
// suppresses this code so no duplicate toast fires).
export const isSlotSelectionRequired = (e: unknown): boolean =>
  (e as any)?.response?.data?.code === 'SLOT_SELECTION_REQUIRED';
